import axios from "../api/axiosinstance";

const MeetingApi = {
  myMeetings: () => axios.get("/meetings/my"),

  getSlots: (date, meetingId = "") =>
    axios.get("/meeting-booking/slots", {
      params: {
        date,
        ...(meetingId ? { meetingId } : {}),
      },
    }),

  cancel: (id) => axios.put(`/meetings/${id}/cancel`),

  complete: (id) => axios.put(`/meetings/${id}/complete`),

  reschedule: (id, data) =>
    axios.put(`/meetings/${id}/reschedule`, data),

  dashboard: () => axios.get("/meetings/dashboard"),
};

export default MeetingApi;